'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { SessionProvider } from 'next-auth/react';
import { Toaster } from '@/components/ui/sonner';
import { useState, useEffect } from 'react';
import { LanguageProvider } from '@/lib/contexts/LanguageContext';
import { ColorThemeProvider } from '@/lib/contexts/ColorThemeContext';
import { init } from '@inleads/event-logger';

const INLEADS_API_KEY = '70bfe7d2-3421-4706-aa3a-d2cb4597b2a1';

export function Providers({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    try { init(INLEADS_API_KEY); } catch {}
  }, []);
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 60 * 1000, // 1 minute
            refetchOnWindowFocus: false,
            retry: 1,
          },
        },
      })
  );

  return (
    <SessionProvider>
      <QueryClientProvider client={queryClient}>
        <ColorThemeProvider>
          <LanguageProvider>
            {children}
            <Toaster />
          </LanguageProvider>
        </ColorThemeProvider>
      </QueryClientProvider>
    </SessionProvider>
  );
}
